// extracted by mini-css-extract-plugin
export default {"headerWrapper":"af1d321b11b8daa0","checkboxWrapper":"_69baea241bed059a","checkbox":"b5df0116494cd4c9","checkboxText":"_30aa74bbe180eff8"};